import { normalizePublicLandingUrl } from '../../landingPage/publicLandingUrl';

function CoaResultsButton({ coaUrl, testId = 'coa-results-view-link' }: { coaUrl: string; testId?: string }) {
    const safeCoaUrl = normalizePublicLandingUrl(coaUrl);

    if (!safeCoaUrl) return null;

    return (
        <a className="coa-results-button" href={safeCoaUrl} target="_blank" rel="noopener noreferrer" data-testid={testId}>
            <span data-testid={`${testId}-button`}>
                View COA Results
            </span>
        </a>
    );

}

export default CoaResultsButton;
